import React from 'react';
import { Provider } from 'react-redux';
import 'utilities/styles/index.scss';
import SiPayPanel from '30pay/30pay.index';
import store from './redux/store';
import { ConfigProvider } from 'antd';
import fa_IR from 'antd/locale/fa_IR';

function App() {
    return (
        <Provider store={store}>
            <ConfigProvider locale={fa_IR}>
                <SiPayPanel />
            </ConfigProvider>
        </Provider>
    );
}

export default App;
